import React, { useEffect } from 'react';
import { Card } from 'antd';
import ExpenseList from '../../components/Expense/ExpenseList';
import { useExpense } from '../../store/expenseContext';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const ExpenseListPage: React.FC = () => {
    const { fetchExpenses } = useExpense();
    const navigate = useNavigate();

    useEffect(() => {
        fetchExpenses();
    }, []);

    const handleEdit = (expense: any) => {
        navigate(`/expenses/form/${expense.id || expense._id}`);
    };

    return (
        <div style={{ padding: 16 }}>
            <Card title={t('expenseList')} variant="outlined">
                <ExpenseList onEdit={handleEdit} />
            </Card>
        </div>
    );
};

export default ExpenseListPage;
